import styled from "styled-components";

export const ElementIndicatorStyled = styled.div`
  width: 100%;
  height: 3px;
  background: ${props => props.indicator ? props.color : '#8e8e8e'};
  margin-right: ${props => !props.first ? '0px' : '10px'};
`;